<template>
  <div class="Rule">
    <r_header></r_header>
    <side_bar :links="links"></side_bar>
  </div>
</template>

<script>
 // @ is an alias to /src

 import SideBar from '@/components/SideBar.vue';
 import RHeader from '@/components/frontpage/Header.vue';
 import MyButton from '@/components/Button.vue';
 import VueMarkdown from 'vue-markdown'
 

 export default {
   name: 'Rule',
   computed: {
     links () {
       return this.$store.state.sbar.linksRule
     },
     buttonStyle() {
       return {
         width: '62.5vw'
       }
     }
   },
   data () {
     return {
       rule: ''
     }
   },
   mounted() {
       this.$http.get('/oss/aialgorithm/markdown/chqs.md')
           .then(res => {
             this.rule = res.data
       })
   },
   methods: {
     download() {
       window.open('/oss/aialgorithm/markdown/%E2%80%9C%20%E5%B0%91%E5%B9%B4%E7%A1%85%E8%B0%B7%20%E2%80%9D%20AI%E7%AE%97%E6%B3%95%E7%AB%9E%E6%8A%80%E8%B5%9B%E8%B5%9B%E5%88%B6%E8%A7%84%E5%88%99-Final.pdf',
        '_blank')
     }
   },

   components: {
     my_button: MyButton,
     r_header: RHeader,
     side_bar: SideBar,
     vue_markdown: VueMarkdown
   }
 }
</script>

<style scoped>
 .markdown{
   margin-top: 5.2vw;
   margin-bottom: 5.2vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: center;
 }
 .md{
   width: 62.5vw;
   text-align: left;
   background-color: #22277c;
   color: white;
   box-sizing: border-box;
   padding: 3.125vw 2.6vw 1vw 2.6vw;
   line-height: 1.875vw;
 }

@media (min-width: 320px) and (max-width: 480px) {
  .md{
    width: 100vw;
   line-height: normal;
  }
 }

</style>
<style>
 .md a{
   color: #FFBA84 !important;
 }
</style>
